var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, OnChanges, ElementRef, AfterViewInit } from '@angular/core';
import { Lightbox, LightboxConfig } from 'angular2-lightbox';
import { LocaleAwareBaseComponent } from './../../../seo/locale-aware-base.component';
import { ListTrackingService } from './../../../utils/list-tracking.service';
var ImagesCarouselBaseComponent = /** @class */ (function (_super) {
    __extends(ImagesCarouselBaseComponent, _super);
    function ImagesCarouselBaseComponent(_lightbox, _lighboxConfig, listTrackingService, window) {
        var _this = _super.call(this) || this;
        _this._lightbox = _lightbox;
        _this._lighboxConfig = _lighboxConfig;
        _this.listTrackingService = listTrackingService;
        _this.window = window;
        _this._images = [];
        _this.emitSlideChange = new EventEmitter();
        _this.autoSlideInterval = 7000;
        _this.scrollPosCanChange = false;
        _this.thumbnailsScrollVals = [];
        _this.isAutoSlideActive = true;
        _this.isZoomDisabled = false;
        _this.refreshTimer();
        return _this;
    }
    Object.defineProperty(ImagesCarouselBaseComponent.prototype, "images", {
        get: function () {
            return this._images;
        },
        set: function (images) {
            this._images = images;
            this._albums = [];
            for (var _i = 0, images_1 = images; _i < images_1.length; _i++) {
                var image = images_1[_i];
                var album = {
                    src: image.url,
                    caption: image.title,
                    thumb: image.width_560_url ? image.width_560_url : image.url
                };
                this._albums.push(album);
            }
        },
        enumerable: true,
        configurable: true
    });
    ImagesCarouselBaseComponent.prototype.ngOnInit = function () {
        this.currentSlideNumber = 0;
        this.onSlideChange(this.currentSlideNumber);
        this.initLightbox(this.images);
        this.thumbnailsListWidth = this.images.length * 140;
    };
    ImagesCarouselBaseComponent.prototype.ngOnChanges = function () {
        // this.initLightbox(this.images);
        // if (this.images[0])
        // this.updateCurrentSlide(0, undefined);
    };
    ImagesCarouselBaseComponent.prototype.ngAfterViewInit = function () {
        if (this.images.length > 1) {
            this.setThumbnailsScrollVals(140);
            this.setThumbnailsListScrollPosition();
            this.scrollPosCanChange = true;
        }
    };
    ImagesCarouselBaseComponent.prototype.setThumbnailsScrollVals = function (thumbWidth) {
        var imgNr = this.images.length;
        var centerElem = Math.floor(imgNr / 2);
        var centerScrollVal = 0;
        if (this.thumbnailsView)
            centerScrollVal = Math.abs(this.thumbnailsView.nativeElement.offsetWidth / 2 - this.thumbnailsListWidth / 2);
        else
            this.scrollPosCanChange = false;
        if (imgNr > 1)
            for (var i = 0; i <= imgNr; i++)
                if (imgNr % 2 === 0) {
                    if (i <= centerElem)
                        this.thumbnailsScrollVals[i] = centerScrollVal - (thumbWidth / 2) - (centerElem - i - 1) * thumbWidth;
                    else
                        this.thumbnailsScrollVals[i] = centerScrollVal + (thumbWidth / 2) + (i - centerElem) * thumbWidth;
                }
                else {
                    if (i < centerElem)
                        this.thumbnailsScrollVals[i] = centerScrollVal - (centerElem - i) * thumbWidth;
                    else if (i > centerElem)
                        this.thumbnailsScrollVals[i] = centerScrollVal + (i - centerElem) * thumbWidth;
                    else
                        this.thumbnailsScrollVals[i] = centerScrollVal;
                }
    };
    ImagesCarouselBaseComponent.prototype.setThumbnailsListScrollPosition = function (slideNumber) {
        if (this.images.length > 1 && this.thumbnailsList)
            if (!slideNumber)
                this.thumbnailsList.nativeElement.scrollLeft = 0;
            else
                this.thumbnailsList.nativeElement.scrollLeft = this.thumbnailsScrollVals[slideNumber];
    };
    ImagesCarouselBaseComponent.prototype.open = function (index, event) {
        if (event)
            event.stopPropagation();
        if (this.window) {
            this._lighboxConfig.positionFromTop = 0;
            this._lighboxConfig.centerVertically = true;
            this._lighboxConfig.fitImageInViewPort = true;
        }
        this._lightbox.open(this._albums, index, { wrapAround: true, showImageNumberLabel: true });
    };
    ImagesCarouselBaseComponent.prototype.startAutoRotation = function () {
        var _this = this;
        if (this.images.length > 1)
            if (this.window)
                this.autoSlideTimer = setInterval(function () {
                    if (_this.isAutoSlideActive) {
                        _this.getNext(undefined);
                    }
                }, this.autoSlideInterval);
    };
    ImagesCarouselBaseComponent.prototype.initLightbox = function (images) {
        this._lighboxConfig.fadeDuration = 1;
    };
    ImagesCarouselBaseComponent.prototype.refreshTimer = function () {
        clearInterval(this.autoSlideTimer);
        this.startAutoRotation();
    };
    ImagesCarouselBaseComponent.prototype.onSlideChange = function (slideNumber) {
        this.emitSlideChange.emit({
            imageUrl: this.images[slideNumber].url,
            slideNumber: slideNumber
        });
    };
    ImagesCarouselBaseComponent.prototype.updateCurrentSlide = function (slideNumber, event) {
        if (event)
            event.stopPropagation();
        this.currentSlideNumber = slideNumber;
        this.onSlideChange(this.currentSlideNumber);
        this.refreshTimer();
        if (this.window)
            // Same as hover-scroll.directive (should not interfere)
            if (this.window.innerWidth < 600)
                this.updateThumbnailsListScrollPosition(slideNumber);
    };
    ImagesCarouselBaseComponent.prototype.updateThumbnailsListScrollPosition = function (slideNumber) {
        if (this.scrollPosCanChange && this.images.length > 1)
            this.setThumbnailsListScrollPosition(slideNumber);
    };
    ImagesCarouselBaseComponent.prototype.getPrevious = function (event) {
        if (event)
            event.stopPropagation();
        if (this.currentSlideNumber === 0)
            this.currentSlideNumber = this.images.length - 1;
        else
            this.currentSlideNumber--;
        this.onSlideChange(this.currentSlideNumber);
        this.refreshTimer();
        this.updateThumbnailsListScrollPosition(this.currentSlideNumber);
    };
    ImagesCarouselBaseComponent.prototype.getNext = function (event) {
        if (event)
            event.stopPropagation();
        if (this.currentSlideNumber === this.images.length - 1)
            this.currentSlideNumber = 0;
        else
            this.currentSlideNumber++;
        this.onSlideChange(this.currentSlideNumber);
        this.refreshTimer();
        this.updateThumbnailsListScrollPosition(this.currentSlideNumber);
    };
    return ImagesCarouselBaseComponent;
}(LocaleAwareBaseComponent));
export { ImagesCarouselBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/images-carousel-base/images-carousel-base.component.ts.pre-build-optimizer.js